







































































































import { Component, Prop, Vue, Watch } from "@/shared/vuepack";
import {
  ManagedExpenseFilterType,
  hsabExpenseOriginatorTypeMap,
  hsabExpenseCategoryMap,
  HsabExpenseResponse,
  SortOrder,
  HsabExpenseFormType,
  ManagedExpensesSortableColumns,
  ManagedExpenseResponse,
  UnusedDistributionResponse,
  ManagedExpenseType,
  HsabExpenseOriginator
} from "@/shared/types";
import { formatCurrency } from "@/shared/currency";
import moment from "moment";
import _ from "lodash";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import Paginator from "@/shared/components/ui/Paginator.vue";
import AccountHolderWidgetBase from "@/employer/components/partner-ee-service/AccountHolderWidgetBase.vue";
import HsabExpenseReimbursementStatusPill from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseReimbursementStatusPill.vue";
import AccountHolderExpenseModal from "@/employer/components/partner-ee-service/AccountHolderExpenseModal.vue";
import { useManagedExpenseStore } from "@/employee/store/managedExpense";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";
import { expenseCategoryIcon, expenseSourceIcon } from "@/shared/awesomeIconMapper";

@Component({
  components: {
    GenericLoadingSpinner,
    AccountHolderWidgetBase,
    HsabExpenseReimbursementStatusPill,
    AccountHolderExpenseModal,
    Paginator
  }
})
export default class AccountHolderExpenses extends Vue {
  formatCurrency = formatCurrency;
  managedExpensesStore = useManagedExpenseStore();
  hsabExpenseStore = useHsabExpenseStore();
  loaded = false;
  expenseCategoryIcon = expenseCategoryIcon;
  expenseSourceIcon = expenseSourceIcon;
  hsabExpenseOriginatorTypeMap = hsabExpenseOriginatorTypeMap;
  hsabExpenseCategoryMap = hsabExpenseCategoryMap;
  ManagedExpenseFilterType = ManagedExpenseFilterType;
  HsabExpenseFormType = HsabExpenseFormType;

  sortDescending = false;
  showExpenseModal = false;
  sortOption = ManagedExpensesSortableColumns.Date;
  expense: HsabExpenseResponse = null;
  unusedDistribution: UnusedDistributionResponse = null;
  hsabExpenseFormType: HsabExpenseFormType = HsabExpenseFormType.ExpenseManagement;

  @Prop({ default: () => ManagedExpenseFilterType.MyExpenses })
  filter: ManagedExpenseFilterType;

  @Prop({ required: true })
  username: string;

  @Prop({ required: true })
  partnerId: number;
  mounted () {
    this.loadData();
  }
  get isLoading () {
    return this.managedExpensesStore.isCurrentPageLoading;
  }

  get isLoaded () {
    return this.managedExpensesStore.isCurrentPageLoaded;
  }

  get isFailed () {
    return this.managedExpensesStore.isCurrentPageLoadFailed;
  }

  get hasData () {
    return this.items && this.items.length > 0;
  }
  get noRecordsFound (): boolean {
    return !this.hasData && this.filter === ManagedExpenseFilterType.MyExpenses;
  }
  loadData () {
    if (!this.loaded) {
      const args = { username: this.username, partnerId: this.partnerId };
      this.managedExpensesStore.loadManagedExpensesByPage(1, this.filter, args);
      this.loaded = true;
    }
  }
  get currentPage () {
    return this.managedExpensesStore.currentPageNumber;
  }

  get pageCount () {
    return this.managedExpensesStore.totalPageCount;
  }

  get hasPages () {
    return this.managedExpensesStore.totalPageCount > 0;
  }
  get items () {
   return this.managedExpensesStore.currentPageItems;
  }

  onSwitchPage (pageNumber: number) {
    const args = { username: this.username, partnerId: this.partnerId };
    this.managedExpensesStore.loadManagedExpensesByPage(pageNumber, this.filter, args);
  }
  getFormattedDate (date?: string): string {
    return date && moment(date).format("MMM D, YYYY") || "(unknown)";
  }
  formattedOriginator (originator: HsabExpenseOriginator) {
    if (originator) {
      return this.hsabExpenseOriginatorTypeMap[originator];
    }
    return "Unknown";
  }
  get showTalonClaims (): boolean {
    return false;
  }
  onFilterClicked (filter: ManagedExpenseFilterType) {
    if (filter !== this.filter) {
      this.managedExpensesStore.resetFilters();
      this.filter = filter;
      const args = { username: this.username, partnerId: this.partnerId };
      this.managedExpensesStore.loadManagedExpensesByPage(1, this.filter, args);
    }
  }
  onSortChanged (ctx) {
    this.sortDescending = ctx.sortDesc;
    const order = ctx.sortDesc ? SortOrder.Descending : SortOrder.Ascending;
    let sortBy = ManagedExpensesSortableColumns.Date;
    switch (ctx.sortBy) {
      case "amount":
        sortBy = ManagedExpensesSortableColumns.Amount;
        break;
      case "provider":
        sortBy = ManagedExpensesSortableColumns.Provider;
        break;
      case "dateOfService":
        sortBy = ManagedExpensesSortableColumns.Date;
        break;
      case "status":
        sortBy = ManagedExpensesSortableColumns.Status;
        break;
      case "planName":
        sortBy = ManagedExpensesSortableColumns.PlanName;
        break;
      case "originator":
        sortBy = ManagedExpensesSortableColumns.Source;
        break;
      case "created":
        sortBy = ManagedExpensesSortableColumns.Created;
        break;
    }
    this.sortOption = ctx.sortBy;
    const args = { username: this.username, partnerId: this.partnerId };
    this.managedExpensesStore.setSortByColumnAndSortOrderAndFilter(sortBy, order, this.filter, args);
  }
  async onRowClicked (item: ManagedExpenseResponse, index: number) {
    const args = { username: this.username, partnerId: this.partnerId };
    if (item.managedExpenseType === ManagedExpenseType.Transaction) {
      this.unusedDistribution = await this.hsabExpenseStore.loadDebitCardReimbursementById(item.reimbursementId, args);
      this.hsabExpenseFormType = HsabExpenseFormType.TransactionItem;
    } else {
      this.expense = await this.hsabExpenseStore.loadExpenseById(item.expenseId, true, args);
      this.hsabExpenseFormType = HsabExpenseFormType.ExpenseManagement;
    }
    this.showExpenseModal = true;
  }
  handleOnEditClose () {
    this.showExpenseModal = false;
  }
  listFields = [
  {
    key: "provider",
    label: "Expense Provider",
    thClass: "text-left",
    tdClass: "align-middle",
    sortable: true
  },
  {
    key: "expenseCategory",
    label: "Category",
    thClass: "text-left",
    tdClass: "align-middle",
    sortable: false
  },
  {
    key: "amount",
    label: "Amount",
    thClass: "text-left",
    tdClass: "align-middle",
    sortable: true
  },
  {
    key: "dateOfService",
    label: "Date of Service",
    thClass: "",
    tdClass: "align-middle",
    sortable: true
  },
  {
    key: "created",
    label: "Date Created",
    thClass: "",
    tdClass: "align-middle",
    sortable: true
  },
  {
    key: "lastModified",
    label: "Last Modified",
    thClass: "",
    tdClass: "align-middle",
    sortable: false
  },
  {
    key: "originator",
    label: "Originator",
    thClass: "text-left",
    tdClass: "align-middle",
    sortable: true
  },
  {
    key: "planName",
    label: "Plan Name",
    thClass: "text-left",
    tdClass: "align-middle",
    sortable: true
  },
  {
    key: "showErrorIndicator",
    label: "",
    thClass: "text-right",
    tdClass: ["text-right"],
    sortable: false
  },
  {
    key: "status",
    label: "Status",
    thClass: "",
    tdClass: "align-middle",
    sortable: true
  }];
}
